<script lang="ts" setup>
import { MenuItem } from '@/types';
defineEmits(['clicked']);
defineProps<{ item: MenuItem }>();
function isActive(to: string) {
    const route = useRoute();
    if (route.matched && route.matched[0]) {
        let navTo = to;
        let path = route.matched[0].path;
        if ((route.params as any).ty) {
            path = route.matched[0].path.replace('/:ty', '');
            const s = navTo.split('/');
            navTo = s.slice(0, s.length - 1).join('/');
        }

        return navTo === path || (path === '/qualityreport' && navTo === '/');
    }
    return route.fullPath === to;
}
</script>
<template>
    <SimpleCardTitle>{{ item.title }}</SimpleCardTitle>
    <div v-if="item.children" class="flex flex-col">
        <template v-for="child in item.children" :key="child.key">
            <router-link
                v-if="child.to"
                v-focus-on-click
                :class="[
                    'menu-item rounded-xl mb-1 text-sm px-3 py-[.45rem]',
                    'hover:bg-zinc-100 dark:hover:bg-surface-700',
                    'outline-0',
                    'focus:outline-1',
                    'focus:outline-surface-400/35',
                    'dark:focus:outline-blue-600',
                    'outline-offset-1',
                    'outline',
                    'flex',
                    'items-center',
                    'justify-start',
                    {
                        'text-blue-600 dark:text-blue-400': isActive(child.to)
                    }
                ]"
                active-class="text-blue-600 dark:text-blue-400"
                :to="child.to"
                exact-active-class="text-blue-600 dark:text-blue-400"
                @click.prevent.stop="$emit('clicked')"
            >
                <span class="w-7 flex justify-start items-center">
                    <i :class="child.icon" />
                </span>
                <span>{{ child.title }}</span>
            </router-link>
        </template>
    </div>
</template>
